import { EActivityEvent } from "@repo-sapiens/data-access-models";
import { UserContext } from "../context";
import { useContext, useEffect } from "react";
import { recordActivity } from "@repo-sapiens/helpers";
import { config } from "../config";

let timeout: NodeJS.Timeout;
export function usePageViewed(event: EActivityEvent) {
  const { state: userState } = useContext(UserContext);

  useEffect(() => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      if (userState?._id) {
        recordActivity(config.apiUrl, {
          data: {
            user: userState?._id,
            event,
            source: "web",
            data: {},
          },
        });
      }
    }, 1000);
  }, [userState?._id, event]);
}
